export default "__VITE_ASSET__CaD2TeNz__"